module.exports = __webpack_public_path__ + "img/bg_whd.5a84bbe3.png";